import './sections-css/Footer.css'
export default function Footer() {
    return (
        <footer>
            <p>Copyright © 2022 Golden Dine website</p>
            <p>All rights reserved</p>
        </footer>
    );
}
